module.exports = __webpack_public_path__ + "img/2.82b97c6c.jpg";